'use client';
import { useI18n } from '@/components/public/i18n/LocaleProvider';
import type { ElinaReference } from '@/lib/public/elina-reference';
import './elina-references.css';

export default function ElinaReferences({ references = [] }: { references?: ElinaReference[] }) {
  const { t } = useI18n();
  if (!references.length) return null;
  return <div className="elina-references" aria-label={t('Les références de votre projet')}>
    {references.map(reference => <details key={reference.url}>
      <summary><span>{t(reference.status === 'documented' || reference.status === 'read' ? 'Référence prise en compte' : 'Référence à compléter')}</span><strong>{reference.title}</strong></summary>
      <p>{t({
        documented: 'Fonctions documentées de la démo RDV-Partners. Les données sont fictives ; les raccordements de production restent à préciser.',
        read: 'Lecture des pages publiques listées ci-dessous. Les fonctions interactives et les connexions internes restent à vérifier.',
        limited: 'La page est accessible, mais son contenu lisible est limité. Une capture ou une description ciblée peut compléter la référence.',
        unavailable: 'La lecture automatique de cette page n’a pas abouti. Votre demande reste prise en compte ; vous pouvez préciser les fonctions à reprendre.',
      }[reference.status])}</p>
      {reference.features.length > 0 && <ul>{reference.features.map(feature => <li key={feature}>{t(feature)}</li>)}</ul>}
      <p className="elina-reference-date">{t(reference.status === 'documented' ? 'Inventaire vérifié le {date}' : 'Lecture tentée le {date}', { date: reference.checkedAt })}</p>
      <a href={reference.url} target="_blank" rel="noopener noreferrer">{t('Ouvrir la référence')} ↗</a>
      {reference.pages.filter(url => url !== reference.url).map(url => <a key={url} href={url} target="_blank" rel="noopener noreferrer">{new URL(url).hostname}{new URL(url).pathname} ↗</a>)}
    </details>)}
  </div>;
}
